import { paths } from 'routes/paths';
import ApplicationsIcon from 'assets/ApplicationsIcon';
import WorkOrdersIcon from 'assets/WorkOrdersIcon';
import { RecordSourceType } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { LinkedRecordType, LinkedRecordTypeDescriptor } from './types';

/**
 * Viewing: both types are reached through their landing route with the id on
 * `location.state`, which is how the operations screens select a record; a
 * second `history.push` argument would nest it as `state.state`, where
 * `SummaryParamsContext` can't read it.
 */
const operationLocation = (pathname: string) => (
  id: string,
  recordName?: string
) => ({
  pathname,
  search: recordName ? `?search=${encodeURIComponent(recordName)}` : '',
  state: { operationId: id }
});

/**
 * Editing: a dedicated route, not the landing one — `RouteAdmin` renders the
 * edit flow from the path itself, and the step form hydrates from the `:id`
 * param, so this carries no `location.state`.
 */
const operationEditLocation = (pathname: string) => (id: string) =>
  `${pathname}/${id}/edit`;

export const LINKED_RECORD_TYPE_DESCRIPTORS: Partial<Record<
  LinkedRecordType,
  LinkedRecordTypeDescriptor
>> = {
  [RecordSourceType.WORK_ORDER]: {
    type: RecordSourceType.WORK_ORDER,
    Icon: WorkOrdersIcon,
    label: 'WORK ORDER',
    typeName: 'Work Order',
    iconHoverFill: '#F0C355',
    goToActionLabel: 'Go to Work Order',
    editPath: operationEditLocation(paths.workOrders),
    viewPath: operationLocation(paths.workOrders)
  },
  [RecordSourceType.APPLICATION]: {
    type: RecordSourceType.APPLICATION,
    Icon: ApplicationsIcon,
    label: 'APPLICATION',
    typeName: 'Application',
    iconHoverFill: '#31B4F2',
    goToActionLabel: 'Go to Application',
    editPath: operationEditLocation(paths.applications),
    viewPath: operationLocation(paths.applications)
  }
};

export const getLinkedRecordDescriptor = (
  type: LinkedRecordType
): LinkedRecordTypeDescriptor | undefined =>
  LINKED_RECORD_TYPE_DESCRIPTORS[type];

export default LINKED_RECORD_TYPE_DESCRIPTORS;
